export default __webpack_public_path__ + "static/media/data_overview.1212a7fc.png";